export function createTrackConfig() {
  return {
    poizon_common_click(platform: string, dataset: any) {
      console.log('poizon_common_click dataset', dataset)
      const { current_page, block_type, product_id, button_title } = dataset || {}
      return {
        current_page,
        block_type,
        product_id,
        button_title,
      }
    },
    poizon_common_exposure(platform: string, dataset: any) {
      console.log('poizon_common_exposure dataset', dataset)
      const { current_page, block_type, spu_id } = dataset || {}
      return {
        current_page,
        block_type,
        spu_id,
      }
    },
    poizon_trade_rank_list_product_click(platform: string, dataset: any) {
      console.log('poizon_trade_rank_list_product_click dataset', dataset)
      const {
        current_page,
        block_type,
        position,
        spu_id,
        poizon_list_id,
        poizon_trade_tab_id,
        poizon_level_2_tab_id,
      } = dataset || {}
      return {
        current_page,
        block_type,
        position,
        spu_id,
        poizon_list_id,
        poizon_trade_tab_id,
        poizon_level_2_tab_id,
      }
    },
    poizon_trade_rank_list_product_exposure(platform: string, dataset: any) {
      console.log('poizon_trade_rank_list_product_exposure dataset', dataset)
      const {
        current_page,
        block_type,
        position,
        spu_id,
        poizon_list_id,
        poizon_trade_tab_id,
        poizon_level_2_tab_id,
      } = dataset || {}
      return {
        current_page,
        block_type,
        position,
        spu_id,
        poizon_list_id,
        poizon_trade_tab_id,
        poizon_level_2_tab_id,
      }
    },
  } as any
}
